var styles = ({});
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/pages/Survay/styles.ts
// module id = 1519
// module chunks = 0